// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"183":"5dd5b0b9","406":"66a9728b"}[chunkId] + ".css";
};